import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';

import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

const PageTemplate = css`
  .site-main {
    background: #fff;
    padding-bottom: 4vw;
  }
`;

const GoLiveProcess: React.FunctionComponent = () => (
  <IndexLayout>
    <Helmet>
      <title>Proces "pójścia live" nowego projektu</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>Proces pójścia live projektu w środowisku produkcyjnym</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <h2>Proces "go live" dla typowych projektów, opartych na Alfredzie</h2>
              <small>(Opis może również znaleźć zastosowanie przy pójściu live z projektem opartym na innym CMSie, platformie)</small>
              <p>&nbsp;</p>
              <ol>
                <li>Upewnienie się, że wszystkie niezbędne zadania odnośnie całego projektu, zostały wykonane i projekt jest gotowy do "pójścia live"</li>
                <li>Przygotowanie web serwera produkcyjnego dla projektu (<a href="/jak-stworzyc-webowy-serwer-na-digitalocean/">przeczytaj opis tego procesu</a>) oraz przygotowanie joba w narzędziu CI/CD (Jenkins) w celu późniejszych deployów nowych releasów strony/aplikacji (<a href="/jak-stworzyc-job-na-jenkinsie/">opis procesu znajdziesz tutaj</a>)</li>
                <li>Zacommitowanie wszystkich plików dodanych za pośrednictwem CMSa w środowisku stagingowym do repozytorium projektu lub Git LFS (jeśli jest używany)</li>
                <li>Doprowadzenie do sytuacji, gdzie gotowy projekt znajduje się na branchu <b>develop</b> oraz <b>master</b> i że oba te branche są równe 1:1<br />
                <small>Mała Git'owa pomoc przy wyrównywaniu brancha develop do master:</small><br />
                <pre><code>
git checkout develop<br />
git merge -s ours master<br />
git checkout master<br />
git merge develop</code></pre>
                </li>
                <li>
                  Skopiowanie bazy danych <b>ze środowiska stagingowego i przekopiowanie do środowiska produkcyjnego</b>; checkout brancha na <b>master</b> w środowisku produkcyjnym + upewnienie się, że CI/CD job (na Jenkinsie lub innym) korzysta z tego brancha
                </li>
                <li>
                  Upewnienie się, że projekt działa w 100% prawidłowo w środowisku produkcyjnym (korzystając z lokalnej rezolucji DNS)
                </li>
                <li>
                  Przekazanie managerowi projektu <b>adresu IP serwera produkcyjnego</b>, w celu zmiany <b>A record</b> w ustawieniach domeny (zazwyczaj jest to zadanie wykonywane przez klienta lub przez nas samych, jeśli mamy dostęp)
                </li>
                <li>
                  Jak tylko ustawienia domeny zostały zaktualizowane i projekt jest już widoczny publicznie, należy dokończyć konfigurację SSL/TLS (Let's Encrypt, dedykowany certyfikat SSL lub Cloudflare - <b>patrz odnośnik z punktu drugiego</b> i podążaj za krokami do wykonania, gdy projekt jest już upubliczniony)
                </li>
                <li>
                  Jeśli strona/aplikacja działa już z połączeniem SSL/TLS i jednocześnie korzysta z IMGIX, należy stworzyć nowe źródło na firmowym koncie IMGIX i skonfigurować połączenie do produkcyjnego adresu strony (<a href="/jak-zintegrowac-imgix-na-stronie/">opis procesu</a>); jak tylko źrodło zostało zdeployowane, należy podać adres URL w pliku .env w środowisku produkcyjnym, aby strona korzystała z nowego adresu
                </li>
                <li>
                  Po wykonaniu wszystkich kroków, należy niezwłocznie poinformować managera projektu, aby wykonać kolejne testy projektu i upewnić się, że całość działa prawidłowo
                </li>
              </ol>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default GoLiveProcess;
